import { useTranslation } from 'react-i18next'
import { StyledCommonTipsContent } from '../styled'

const CommonTipsContent: React.FC = () => {
  const { t } = useTranslation()

  return (
    <StyledCommonTipsContent>
      <p className="tips-item">
        <span className="num">1</span>
        <span className="tips">{t('punish_tips_1')}</span>
      </p>
      <p className="tips-item tips-2">
        <span className="num">2</span>
        <span className="tips">{t('punish_tips_2')}</span>
      </p>
    </StyledCommonTipsContent>
  )
}

export default CommonTipsContent
